import 'ag-grid-enterprise' // eslint-disable-line
import { LicenseManager } from 'ag-grid-enterprise' // eslint-disable-line
import LKGrid from './components'
import { reducer, actionTypes, destroy } from './store'

LicenseManager.setLicenseKey(
  'Evaluation_License_Valid_Until_23_April_2018__MTUyNDQzODAwMDAwMA==026f634e7af389e6e87c3f2fb7dcfbf4',
)

export { reducer, actionTypes, destroy }

export default LKGrid
